module.exports = require("./ru-KZ.js");